<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Summary Review</h3>
    </b-card-header>
    <b-card-body>
      <b-list-group class="mb-3">
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <span>Net Profit</span>
          <b-badge variant="primary" pill>{{ economicModel.net_profit_goal | currency }}</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Closed Sales Volume
          <b-badge variant="primary" pill>{{ closedSalesVolume | currency }}</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member !== 1">
          Company GCI
          <b-badge variant="primary" pill>{{ companyGci | currency }}</b-badge>
        </b-list-group-item>

        <b-list-group-item>
          <div class="row">
            <div class="col-sm d-flex justify-content-between align-items-center">
              Closed Units
              <b-badge variant="primary" pill>{{ closedUnits }}</b-badge>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-button v-b-toggle.units-details variant="link" size="sm">Details</b-button>
              <b-collapse id="units-details" class="mt-2">
                <b-list-group class="mb-3">
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Listing Sales
                    <b-badge variant="primary" pill>{{ totalListingsSold }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Buyer Sales
                    <b-badge variant="primary" pill>{{ totalBuyersSold }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member == 0">
                    <span>Listings Sold By You</span>
                    <b-badge variant="primary" pill>{{ cos.listings_sold }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member == 0">
                    <span>Buyers Sold By You</span>
                    <b-badge variant="primary" pill>{{ cos.buyers_sold }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member == 0">
                    Listings Sold By Your Team Members
                    <b-badge variant="primary" pill>{{ teamListings }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member == 0">
                    Buyers Sold By Your Team Members
                    <b-badge variant="primary" pill>{{ teamBuyers }}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
            </div>
          </div>
        </b-list-group-item>

        <b-list-group-item v-if="cos.team_member !== 1">
          <div class="row">
            <div class="col-sm d-flex justify-content-between align-items-center">
              Cost of Sale
              <b-badge variant="primary" pill>{{ calculatedCos | currency }}</b-badge>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-button v-b-toggle.cos-details variant="link" size="sm">Details</b-button>
              <b-collapse id="cos-details" class="mt-2">
                <b-list-group class="mb-3">
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="paidToBroker > 0">
                    Total Paid To Broker:
                    <b-badge variant="primary" pill>{{ paidToBroker | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="annualFranchiseFee > 0">
                    Company Franchise Fee:
                    <b-badge variant="primary" pill>{{ annualFranchiseFee | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member != 2">
                    <span v-if="cos.team_member == 0">
                      Team Member GCI on Listing Sales:
                    </span>
                    <span v-else>
                      Amount Paid to team on Listing Sales:
                    </span>
                    <b-badge variant="primary" pill>{{ teamListingsGci | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member != 2">
                    <span v-if="cos.team_member == 0">
                      Team Member GCI on Buyer Sales:
                    </span>
                    <span v-else>
                      Amount paid to team on Buyer Sales:
                    </span>
                    <b-badge variant="primary" pill>{{ teamBuyersGci | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="isaComp > 0">
                    Amount Paid to ISA's:
                    <b-badge variant="primary" pill>{{ calculatedIsa | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Amount Paid in Referral Fees:
                    <b-badge variant="primary" pill>{{ referralFees | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="adminFees > 0">
                    Total Compensation to Admins Per Transaction:
                    <b-badge variant="primary" pill>{{ adminFees | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="adminFees > 0">
                    Total Compensation to Admins Per Listing Transactions:
                    <b-badge variant="primary" pill>{{ listingAdminFees | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="adminFees > 0">
                    Total Compensation to Admins Per Buyer Transactions:
                    <b-badge variant="primary" pill>{{ buyerAdminFees | currency }}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.additional_cos > 0">
                    Total Additional Cost of Sale:
                    <b-badge variant="primary" pill>{{ cos.additional_cos | currency }}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
            </div>
          </div>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center" v-if="cos.team_member !== 1">
          Cost of Sale %
          <b-badge variant="primary" pill>{{ cosPercent }}%</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Gross Profit
          <b-badge variant="primary" pill>{{ grossProfit | currency }}</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Expenses
          <b-badge variant="primary" pill>{{ yearlyExpenses | currency }}</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Expense %
          <b-badge variant="primary" pill>{{ expensePercent }}%</b-badge>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center">
          Profit %
          <b-badge variant="primary" pill>{{ profitPercent }}%</b-badge>
        </b-list-group-item>

        <b-list-group-item>
          <div class="row">
            <div class="col-sm d-flex justify-content-between align-items-center">
              Activities
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-button v-b-toggle.activities variant="link" size="sm">Details</b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <b-collapse id="activities" class="mt-2">
                <b-list-group class="mb-3">
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Listing Appts Held
                    <b-badge variant="primary" pill>{{ totalApptsHeld }}</b-badge>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Listings Taken
                    <b-badge variant="primary" pill>{{ totalListingsTaken }}</b-badge>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Listings Sold
                    <b-badge variant="primary" pill>{{ totalListingsSold }}</b-badge>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Buyer Consults Held
                    <b-badge variant="primary" pill>{{ totalBuyersHeld }}</b-badge>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Buyers Taken
                    <b-badge variant="primary" pill>{{ totalBuyersTaken }}</b-badge>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total Buyers Sold
                    <b-badge variant="primary" pill>{{ totalBuyersSold }}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  props: {
    year: null
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      economicModel: 'economicModel/economicModel',
      cos: 'cos/cos',
      closedSalesVolume: 'economicModel/closedSalesVolume',
      companyGci: 'economicModel/companyGci',
      closedUnits: 'economicModel/closedUnits',
      totalListingsSold: 'economicModel/totalListingsTaken',
      totalBuyersSold: 'economicModel/totalBuyersSold',
      listingsSold: 'cos/listingsSold',
      buyersSold: 'cos/buyersSold',
      teamListings: 'economicModel/listingsSold',
      teamBuyers: 'economicModel/buyersSold',
      calculatedCos: 'economicModel/calculatedCos',
      paidToBroker: 'economicModel/paidToBroker',
      annualFranchiseFee: 'cos/annualFranchiseFee',
      teamListingsGci: 'economicModel/teamListingsGci',
      teamBuyersGci: 'economicModel/teamBuyersGci',
      calculatedIsa: 'economicModel/calculatedIsa',
      referralFees: 'economicModel/referralFees',
      adminFees: 'economicModel/adminFees',
      listingAdminFees: 'economicModel/listingAdminFees',
      buyerAdminFees: 'economicModel/buyerAdminFees',
      cosPercent: 'economicModel/cosPercent',
      grossProfit: 'economicModel/grossProfit',
      yearlyExpenses: 'cos/yearlyExpenses',
      expensePercent: 'economicModel/expensePercent',
      profitPercent: 'economicModel/profitPercent',
      totalApptsHeld: 'economicModel/totalApptsHeld',
      totalListingsTaken: 'economicModel/totalListingsTaken',
      totalListingsSold: 'economicModel/totalListingsSold',
      totalBuyersHeld: 'economicModel/totalBuyersHeld',
      totalBuyersTaken: 'economicModel/totalBuyersTaken',
      totalBuyersSold: 'economicModel/totalBuyersSold',
      isaComp: 'economicModel/isaComp'
    })
  }
};
</script>